export const graphRowHeight = 7; // in vh
